import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './home.css',
})
export class Home {
  public homeText: string = '';

  constructor() {}

  ngOnInit(): void {
    this.homeText = $localize`Cyklisk kalnder`;
  }
}
